import { Component, OnInit } from '@angular/core';
import { VersionService } from 'src/app/core/services/version.service';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
    standalone: false
})



export class FooterComponent implements OnInit {
  public now: Date = new Date();
  public version;
  private intervalId: any;

  constructor(private versionService: VersionService) {
    this.intervalId = setInterval(() => {
      this.version = versionService.version;
      this.now = new Date();
    }, 1000);
  }

  ngOnInit(): void {
  }

  ngOnDestroy(): void {
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  }

}
